module.exports = __webpack_public_path__ + "assets/img/Logitech-Workspace-w960.eedb9de7.webp";